import React, { useRef } from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { Container, Stack } from '@fiverr-private/layout_components';
import withContext from '../../../lib/withContext';
import { Nav, NavItem, Layout, NavDivider, JoinLink, Logo, NavIcon } from '../../blocks';
import { Search, LoginLink, LeanLocaleSettingsLink, ConnectToAiNavigation } from '../../components';
import { GuestBecomeSellerNavItem } from '../../components/GuestBecomeSellerNavItem';
import { useStickyTriggers } from '../../hooks/useStickyTriggers';
import { localeNavWrapper } from '../LoggedOut/LoggedOutLocaleNavItem.ve.css';
import { LEGACY_SEARCH_BAR_PACKAGE_SELECTOR } from './constants';

interface LoggedOutHomepageProps {
    isLohpRework?: boolean;
}

export const LoggedOutHomepage = ({ isLohpRework = false }: LoggedOutHomepageProps) => {
    const headerRef = useRef<HTMLDivElement>(null);

    const { showSearch } = useStickyTriggers({
        headerRef,
        selectors: {
            showSearch: LEGACY_SEARCH_BAR_PACKAGE_SELECTOR,
        },
    });

    const localeItem = (
        <NavItem key="locale" displayFrom="md">
            <Container className={localeNavWrapper}>
                <LeanLocaleSettingsLink />
            </Container>
        </NavItem>
    );

    const becomeSellerItem = (
        <NavItem key="become-seller" displayFrom="sm">
            <GuestBecomeSellerNavItem copyKey={isLohpRework ? 'freelance_on_fiverr' : 'become_seller'} />
        </NavItem>
    );

    return (
        <Layout ref={headerRef}>
            <Container
                hidden={{
                    default: false,
                    lg: true,
                }}
            >
                <NavIcon />
            </Container>
            <Stack hidden={{ default: showSearch, sm: false }} marginRight={{ default: '0', sm: 'auto' }}>
                <Logo href={pathfinder('root', {}, { query: { source: 'top_nav' } })} />
            </Stack>
            <Container width="100%" display="block" hidden={{ default: !showSearch, md: false }}>
                <Search show={showSearch} showOnMobile fullWidth />
            </Container>
            <Nav gap="2">
                <NavItem displayFrom="lg">
                    <ConnectToAiNavigation />
                </NavItem>
                {isLohpRework ? [becomeSellerItem, localeItem] : [localeItem, becomeSellerItem]}
                <NavDivider displayFrom="sm" />
                <NavItem displayFrom="sm">
                    <LoginLink />
                </NavItem>
                <NavItem>
                    <JoinLink />
                </NavItem>
            </Nav>
        </Layout>
    );
};

export default withContext(LoggedOutHomepage);
